module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"tab":{"article":"掲示物届出及び遮断","brand_user":"作成者届出及び遮断"},"spam_type_label":"届出事由 (必須)","reason_placeholder":"{max_length}字以内で届出内容を入力してください。","hint":"届出項目に含まれていない内容はその他を選択して届出内容を作成してください。","hint2":"届け出た内容は管理者の検討後、内部方針に基づいて措置が行われます。","block_label":"遮断可否","block_message":{"article":"該当掲示物を遮断します。","brand_user":"該当作成者の掲示物を全て遮断します。"}}}')
  delete Component.options._Ctor
}
